import { isAdmin } from '@utils/Auth';
import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = () => {
    const [isAbleToAccess, setIsAbleToAccess] = useState<Boolean>();

    useEffect(() => {
        setIsAbleToAccess(true);
        isAdmin().then((isUserAdmin) => {
            setIsAbleToAccess(isUserAdmin || false);
        }).catch(e => setIsAbleToAccess(false));
    }, []);

    return isAbleToAccess === undefined ? null : isAbleToAccess ? <Outlet /> : <Navigate to="/auth/login" />;

};

export default AdminRoute;